const EMISSIONS_BY_SOURCE = 'Emissions by source';
const EMISSIONS_COLORS = [
  '#be531c',
  '#ce7548',
  '#a2d45e',
  '#37a041',
  '#006837',
  '#5b6670',
  '#7f7f7f',
  '#35424a',
  '#958e51',
  '#b21702',
];

const labelsForGraph = {
  PreviousAssessment: 'Previous Assessment',
  TopTenPercent: 'Alltech Top 10%',
  AlltechAverage: 'Alltech average',
};
const labelsForGraphDrill = {
  // PreviousAssessment: 'Previous Assessment',
  TopTenPercent: 'Alltech Top 10%',
  AlltechAverage: 'Alltech average',
  TopTenPercentCarbonBased: 'Top 10 Carbon Based',
  TopResult: 'Top Result',
  // Value: 'Selected project'
};

const PERFORMANCE_INDICATORS = {
  good: {
    word: 'Good',
    color: '#37a041',
  },
  satisfactory: {
    word: 'Satisfactory',
    color: '#fed73c',
  },
  unsatisfactory: {
    word: 'Unsatisfactory',
    color: '#ff333b',
  },
};

const PERFORMANCE_NUMBERS = {
  good: 901,
  satisfactory: 1200,
  unsatisfactory: 1201,
};

const getPerformanceIndicatorByValue = (value: any) => {
  if (value < PERFORMANCE_NUMBERS.good) {
    return PERFORMANCE_INDICATORS.good;
  } else if (value <= PERFORMANCE_NUMBERS.satisfactory) {
    return PERFORMANCE_INDICATORS.satisfactory;
  } else {
    return PERFORMANCE_INDICATORS.unsatisfactory;
  }
};

const getPerformanceIndicatorByValueNew = (value: any, good: any, bad: any) => {
  if (value < good) {
    return PERFORMANCE_INDICATORS.good;
  } else if (value <= bad) {
    return PERFORMANCE_INDICATORS.satisfactory;
  } else {
    return PERFORMANCE_INDICATORS.unsatisfactory;
  }
};

export {
  PERFORMANCE_INDICATORS,
  getPerformanceIndicatorByValue,
  getPerformanceIndicatorByValueNew,
  EMISSIONS_COLORS,
  EMISSIONS_BY_SOURCE,
  labelsForGraph,
  labelsForGraphDrill,
};
